"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(mode) {
    return ['SCRIPT', 'DEBUG', mode];
}
exports.transformArguments = transformArguments;
